<div class="main">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
                 size="medium"
                 color="#fff"
                 type="line-spin-clockwise-fade"
                 [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="row m-0">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <h2 class="page-title" tabindex="0">{{'notification.notifications' | translate}}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12 m-0">
                    <xng-breadcrumb separator=" > ">
                        <ng-container *xngBreadcrumbItem="let breadcrumb">
                            <span *ngIf="breadcrumb">{{ 'breadcrumb.' + breadcrumb | translate }}</span>
                        </ng-container>
                    </xng-breadcrumb>
                </div>
                <div class="col-12 text-right btns" *ngxPermissionsExcept="['Activate','Expired']">
                    <button tabindex="0" routerLink="/main/notifications/approve-notifications" routeLinkActive="active" title="{{'breadcrumb.approve-notifications' | translate}}" class="btn btn-blue btn-h-blue mb-2" *ngIf="approver">
                        {{'breadcrumb.approve-notifications' | translate}}
                    </button>
                    <button tabindex="0" id="add_toggle" type="button" title="{{'notification.add_notification' | translate}}" class="btn btn-green btn-h-green mb-2 ml-2" (click)="toggleShowAddNotificationForm()">
                        {{'notification.add_notification' | translate}}
                    </button>
                    <button tabindex="0" id="cancel_toggle" type="button" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mb-2 ml-2" (click)="toggleShowAddNotificationForm()" hidden>
                        {{'general.cancel' | translate}}
                    </button>
                </div>
            </div>
            <div *ngIf="showAddNotificationForm" class="card col-12 mb-2 border-0 p-0">
                <div class="card-collapse border">
                    <div class="card-header">
                        <h4 class="mb-0">{{'notification.add_notification' | translate}}</h4>
                    </div>
                    <div class="card-body">
                        <div class="row mb-2 btns">
                            <div class="col-12" >
                                <span tabindex="0">{{'notification.send_to' | translate}}<span class="error">*</span></span><br>
                                    <ng-multiselect-dropdown 
                                        id = "userGroup"
                                        tabindex="0"
                                        placeholder="{{'general.select' | translate}}"
                                        [settings]="dropdownSettings"
                                        [data]="groupList"
                                        [(ngModel)]="selectedGroups"
                                        (onSelect)="onItemSelect($event)"
                                        (onSelectAll)="onSelectAll($event)"
                                        (onDeSelect)="onItemDeSelect($event)"
                                        (onDeSelectAll)="onDeSelectAll($event)"
                                    >
                                    </ng-multiselect-dropdown>
                                <div id="userGroupErr" class="error"></div>
                            </div>
                        </div>
                        <form #saveNot="ngForm" class="w-100 btns" [formGroup]="addNotificationForm" [ngClass]="{ 'was-validated': formSubmitted }" (ngSubmit)="notificationSave(saveNot)" name="form">
                            <div class="row mb-2">  
                                <div class="col-12">
                                    <label for="message">{{'notification.message' | translate}}<span class="error">*</span></label>
                                    <input id="message" formControlName="message" class="form-control" required="required" maxlength="150" [ngClass]="{ 'is-valid': message['valid'], 'is-invalid': message['invalid'] }" />
                                    <ng-container *ngIf="addNotificationForm.get('message').invalid && (addNotificationForm.get('message').touched || addNotificationForm.get('message').dirty) || formSubmitted">
                                        <div *ngIf="addNotificationForm.get('message').hasError('required')" class="error text-left">
                                            {{'general.required_field' | translate}}
                                        </div>
                                        <div *ngIf="addNotificationForm.get('message').hasError('pattern')" class="error text-left">
                                            {{'general.required_field' | translate}}
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    {{'notification.send_noti_by' | translate}}<span class="error">*</span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-12">
                                    <label class="mr-2 mb-0" formArrayName="options" *ngFor="let option of optionsFormArray.controls; let i = index">
                                        <input type="checkbox" [formControlName]="i" [checked]="i==0">
                                        {{constants.sendOptions[i].name | translate}}
                                    </label><br>
                                </div>
                                <div class="col-12 error" id="optionsErr"></div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <fieldset>
                                        <legend class="h6">{{ 'notification.noti_scheduled_msg' | translate }}<span class="error">*</span></legend>
                                        <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                                            <input type="radio" name="schedule" formControlName="schedule" value="1" (click)="getScheduleNoti(1)" [(ngModel)]="scheduleNoti['option']">&nbsp;{{'general.yes' | translate}}
                                        </label>
                                        <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                                            <input type="radio" name="schedule" formControlName="schedule" value="0" (click)="getScheduleNoti(0)" [(ngModel)]="scheduleNoti['option']">&nbsp;No
                                        </label>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="row mb-2" id="scheduled_yes" hidden>
                                <div class="col-3">
                                    <label for="scheduleDate" class="page-title mt-1 mr-1 text-dark mb-0">{{'general.date' | translate}}</label><br>
                                    <mat-form-field class="mm-10 w-100">
                                        <input matInput id="scheduleDate" formControlName="scheduleDate" [matDatepicker]="picker" [min]='currentDate' readonly>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-3">
                                    <label for="hour">{{'general.hour' | translate}}</label>
                                    <select id="hour" class="form-control">
                                        <option *ngFor="let hour of hours" [value]="hour.value">{{hour.name}}</option>
                                    </select>
                                </div>
                                <div id="dpErr" class="dpErr col-12 error mm-10"></div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="btn-toolbar float-right">
                                        <button id="send" class="btn btn-green btn-h-green mb-2" title="{{ 'notification.send' | translate }}" (click)="changeStatus(saveNot)"> {{ 'notification.send' | translate}} </button>
                                        <button id="save" type="submit" class="btn btn-blue btn-h-blue mb-2 ml-2" title="{{ 'general.save' | translate }}"> {{ 'general.save' | translate}} </button>
                                        <button id="schedule" type="submit" class="btn btn-green btn-h-green mb-2 ml-2" title="{{ 'notification.schedule' | translate }}" hidden> {{ 'notification.schedule' | translate}} </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-0">
        <div class="col-12">
            <div class="d-flex flex-row bd-highlight float-right">
                <div class="p-2 bd-highlight">
                    <form [formGroup]="filterNotiForm" (ngSubmit)="applyFilter()">
                        <label for="filterDate" class="page-title mt-1 mr-1 text-dark mb-0">{{'notification.sent_date' | translate}}</label><br>
                        <mat-form-field class="mm-10 w-100">
                            <input id="filterDate" matInput formControlName="filterDate" [matDatepicker]="picker" [min]='min' [max]='currentDate' readonly>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </form>
                </div>
                <div class="p-2 bd-highlight">
                    <label for="filter" class="mb-0">{{'notification.sent_by' | translate}}</label>
                    <input type="text" id="filter" class="form-control m-0 rounded border-secondary" (keyup)="emptyInput()" maxlength="50">
                </div>
                <div class="bd-highlight button-group">
                    <button class="btn remove-filter-btn ml-1" tabindex="0" title="{{ 'general.clear_filter' | translate }}" (click)="clearFilter()">
                        <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
                    </button>
                    <button class="btn apply-filter-btn ml-1" tabindex="0" title="{{ 'general.apply_filter' | translate }}" (click)="applyFilter()">
                        <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-0">
        <div class="col-12">
            <table class="border-top" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" matSortActive="created" matSortDirection="desc" matSortDisableClear>
                <ng-container matColumnDef="message">
                    <th tabindex="0" mat-header-cell *matHeaderCellDef mat-sort-header> {{'notification.message' | translate}} </th>
                    <td mat-cell class="text-break" *matCellDef="let notification"> {{notification.message}} </td>
                </ng-container>
                <ng-container matColumnDef="userGroup">
                    <th tabindex="0" mat-header-cell *matHeaderCellDef> {{'notification.send_to' | translate}} </th>
                    <td mat-cell *matCellDef="let notification">
                        {{ notification.tagName?functionsService.formatMultiGroupName(notification.tagName):"" }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="created">
                    <th tabindex="0" mat-header-cell *matHeaderCellDef mat-sort-header> {{'notification.created_date' | translate}} </th>
                    <td mat-cell *matCellDef="let notification">{{notiDate.convertUTCDateToLocalDate(notification.created)}} </td>
                </ng-container>
                <ng-container matColumnDef="sentDate">
                    <th tabindex="0" mat-header-cell *matHeaderCellDef mat-sort-header> {{'notification.sent_date' | translate}} </th>
                    <td mat-cell *matCellDef="let notification"> {{notification.sentDate!=null&&notification.status==1?notiDate.convertUTCDateToLocalDate(notification.sentDate):""}} </td>
                </ng-container>
                <!-- Active Column -->
                <ng-container matColumnDef="status">
                    <th tabindex="0" class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header> {{'alert.status' | translate}} </th>
                    <td mat-cell *matCellDef="let notification">
                        <i *ngIf="notification.status === 0" class="fa fa-times-circle fa-2x red-text"
                            title="{{'notification.not_sent' | translate}}"></i>
                        <i *ngIf="notification.status === 1" class="fa fa-paper-plane fa-2x green-text"
                            title="{{'notification.sent' | translate}}"></i>
                        <i *ngIf="notification.status === 2" class="fa fa-search fa-2x blue-text"
                            title="{{'notification.in_review_mode' | translate}}"></i>
                        <i *ngIf="notification.status === 3" class="fa fa-clock fa-2x orange-text"
                            title="{{'notification.scheduled' | translate}}"></i>
                    </td>
                </ng-container>
                <!-- Scheduled Column -->
                <ng-container matColumnDef="scheduled">
                    <th tabindex="0" mat-header-cell *matHeaderCellDef mat-sort-header> {{'notification.scheduled' | translate}} </th>
                    <td mat-cell *matCellDef="let notification"> {{notification.scheduled?notiDate.convertUTCDateToLocalDate(notification.scheduled):""}} </td>
                </ng-container>
                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> {{'general.actions' | translate}} </th>
                    <td mat-cell *matCellDef="let notification">
                        <div class="dropdown" ngbDropdown>
                            <button tabindex="0" ngbDropdownToggle class="btn btn-default" title="{{'general.actions' | translate}}"><i class="fa fa-ellipsis-v" title="{{'general.actions' | translate}}"></i></button>
                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-left">
                                <button ngbDropdownItem [routerLink]="['view-notification', notification.id]" routerLinkActive="active" title="{{'alert.details' | translate}}"><i class="fa fa-eye"></i> {{'alert.details' | translate}}</button>
                                <div *ngIf="notification.status==0 || (!approve && !approver && notification.status==3)">
                                    <button ngbDropdownItem (click)="editNotification(notification.id)" *ngxPermissionsExcept="['Activate','Expired']" title="{{'general.edit' | translate}}"><i class="fa fa-pencil"></i> {{'general.edit' | translate}}</button>
                                    <button ngbDropdownItem (click)="sendNotificationPrompt(notification)" *ngxPermissionsExcept="['Activate','Expired']" title="{{'notification.send' | translate}}"><i class="fa fa-envelope"></i> {{'notification.send' | translate}}</button>
                                </div>
                                <div *ngIf="notification.status>1">
                                    <button ngbDropdownItem (click)="cancelNotification(notification)" *ngxPermissionsExcept="['Activate','Expired']" title="{{'notification.cancel_send' | translate}}"><i class="fa fa-times pr-2"></i>{{'notification.cancel_send' | translate}}</button>
                                </div>
                                <div *ngIf="notification.status!=1&&!expired">
                                    <button ngbDropdownItem (click)="deleteNotification(notification)" *ngxPermissionsOnly="['Owner','Admin','SecurityAgent','Supervisor']" title="{{'general.delete' | translate}}"><i class="fa fa-trash"></i> {{'general.delete' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>    
            <mat-paginator tabindex="0" #paginator [length]="totalLength" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="nextPage($event)"></mat-paginator>
        </div>
    </div>
</div>
